module.exports = __webpack_public_path__ + "img/PL08663.6762eb36.png";